module.exports = __webpack_public_path__ + "media/images/weleda_logo-5c107d49ac56972d50748b36ae8d13a3.png";